import React, { useState } from 'react';
import {
  TableRow,
  CellContent,
  Position,
  ProductTableCell,
  EntityMetaData,
  EntityTitle,
  TableCell,
  EntityMeta,
  Link,
  ProductAdditionalInfo,
  MobileFixedWidthTableCell,
  StyledCaret,
  ProductInfoBlock,
} from './chartTable.style';
import formatNumber from 'helpers/formatNumber';
import PositionArrow from 'components/utility/PositionArrow/PositionArrow';
import { IChartTrackData } from 'helpers/interceptors/chartsTableDataInterceptor';

interface IChartTableRowProps {
  trackData: IChartTrackData;
  isLargeScreen: boolean;
}

const wmgDealTypes = ['Wholly Owned', 'P&D', 'Pick Pack and Ship'];

const ChartTableRow: React.FC<IChartTableRowProps> = (props) => {
  const { trackData, isLargeScreen } = props;
  const {
    productTitle,
    position,
    dealTypeList,
    artistName,
    streamCount,
    productId,
    currentPosition,
    previousPosition,
    peakPosition,
    daysOnChart,
    weeksOnChart,
  } = trackData;

  const [isExpanded, setIsExpanded] = useState(false);

  const isWmgProduct = dealTypeList.some((wmgType: string) =>
    wmgDealTypes.includes(wmgType)
  );

  function toggleExpandRow(): void {
    if (!isLargeScreen) setIsExpanded(!isExpanded);
  }

  return (
    <TableRow
      onClick={toggleExpandRow}
      isExpanded={!isLargeScreen && isExpanded}
      isWmgRow={false} // temporary reverted back blue highlight
      isLargeScreen={isLargeScreen}
    >
      {isLargeScreen && (
        <>
          <TableCell>
            <CellContent textAlign="center">
              <Position>
                {formatNumber(currentPosition || position, 'position')}
              </Position>
            </CellContent>
          </TableCell>
          <TableCell>
            <CellContent textAlign="center">
              <PositionArrow
                position={currentPosition}
                previousPosition={previousPosition}
                showTooltip={true}
              ></PositionArrow>
            </CellContent>
          </TableCell>

          <ProductTableCell>
            <CellContent>
              <EntityMetaData>
                <EntityTitle>
                  {isWmgProduct && productId ? (
                    <Link to={`/entity/track/${productId}/overview/summary`}>
                      {productTitle}
                    </Link>
                  ) : (
                    productTitle || '-'
                  )}
                </EntityTitle>
                <EntityMeta>by {artistName || '-'}</EntityMeta>
              </EntityMetaData>
            </CellContent>
          </ProductTableCell>

          <TableCell>
            <CellContent textAlign="center">
              {formatNumber(previousPosition, 'number')}
            </CellContent>
          </TableCell>

          <TableCell>
            <CellContent textAlign="center">
              {formatNumber(peakPosition, 'number')}
            </CellContent>
          </TableCell>
          <TableCell>
            <CellContent textAlign="center">
              {formatNumber(daysOnChart || weeksOnChart, 'number')}
            </CellContent>
          </TableCell>

          <TableCell>
            <CellContent textAlign="center">
              {formatNumber(streamCount, 'number')}
            </CellContent>
          </TableCell>
        </>
      )}
      {!isLargeScreen && (
        <>
          <MobileFixedWidthTableCell>
            <CellContent textAlign="center" smallScreen={!isLargeScreen}>
              <PositionArrow
                position={currentPosition}
                previousPosition={previousPosition}
                showTooltip={true}
              ></PositionArrow>
            </CellContent>
          </MobileFixedWidthTableCell>
          <TableCell>
            <Position smallScreen={!isLargeScreen}>
              {formatNumber(currentPosition || position, 'number')}
            </Position>
          </TableCell>
          <ProductTableCell>
            <CellContent smallScreen={!isLargeScreen}>
              <EntityMetaData>
                <EntityTitle>
                  {isWmgProduct && productId ? (
                    <Link to={`/entity/track/${productId}`}>
                      {productTitle}
                    </Link>
                  ) : (
                    productTitle || '-'
                  )}
                </EntityTitle>
                <EntityMeta>by {artistName || '-'}</EntityMeta>
                <ProductInfoBlock>
                  <ProductAdditionalInfo>STREAMS</ProductAdditionalInfo>{' '}
                  {formatNumber(streamCount, 'number', true)}
                </ProductInfoBlock>
                {isExpanded && (
                  <>
                    <ProductInfoBlock>
                      <ProductAdditionalInfo>
                        days on chart
                      </ProductAdditionalInfo>{' '}
                      {formatNumber(daysOnChart || weeksOnChart, 'number')}
                    </ProductInfoBlock>
                    <ProductInfoBlock>
                      <ProductAdditionalInfo>
                        previous position
                      </ProductAdditionalInfo>{' '}
                      {formatNumber(previousPosition, 'position')}
                    </ProductInfoBlock>
                    <ProductInfoBlock>
                      <ProductAdditionalInfo>
                        peak position
                      </ProductAdditionalInfo>{' '}
                      {formatNumber(peakPosition, 'position')}
                    </ProductInfoBlock>
                  </>
                )}
              </EntityMetaData>
            </CellContent>
          </ProductTableCell>

          <MobileFixedWidthTableCell>
            <CellContent textAlign="center" smallScreen={!isLargeScreen}>
              <StyledCaret open={isExpanded} />
            </CellContent>
          </MobileFixedWidthTableCell>
        </>
      )}
    </TableRow>
  );
};

export default ChartTableRow;
